import { useContext } from "react";
import { STATEMENT_KEYS } from "../data/statements";
import { Link } from "react-router";
import { LocaleContext } from "../app";
import { Tellit } from "./tellit";

export function ChooseTheme() {
  const { translate } = useContext(LocaleContext);

  return (
    <>
      <Tellit
        name="main"
        url="https://tell-it-production-public.s3.eu-central-1.amazonaws.com/e010485dff9e29aa4f2be6c9/story.json"
      />

      <main className="app__container">
        <div className="card">
          <h2 className="card__title">{translate("intro.title")}</h2>

          {STATEMENT_KEYS.map((key) => (
            <Link to={key} key={key} className="link-card">
              {translate(["statements", key, "shortName"])}
            </Link>
          ))}
        </div>
        <a href={translate("intro.other_topic.url")} className="link">
          {translate("intro.other_topic.text")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="card__link-icon"
          >
            <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
          </svg>
        </a>
      </main>
    </>
  );
}
